import * as React from 'react';
import { Link } from 'react-router-dom';
import { openInANewBrowser } from 'helpers/HelperFunctions';
import { ReactComponent as Feedback } from "assets/icons/insert-comments.svg";
import { Explore, Help } from '@mui/icons-material';
import { Grid2 } from "@mui/material";

const USER_GUIDE_BASE_URL = "https://bhp.service-now.com/now/nav/ui/classic/params/target/%24viewer.do%3Fsysparm_stack%3Dno%26sysparm_sys_id=";
const CURRENT_USER_GUIDE_SYS_ID = "f3bc2eac4722aa5422b6413f016d43a5"; // This is SYS_ID for the PDF from servicenow

export const SubmitTechFeedback = () => {
    openInANewBrowser("mailto:dl-tech-minaus-assetwest-railport-apps@bhp.com");
};

export const EmailSafeWorking = () => {
    openInANewBrowser("mailto:Safeworking.Specialist@bhpbilliton.com");
};

export const NeedDirectionCard = () => (
    <div className="need-direction-card">
        <div>
            <Grid2 container>
                <Grid2 size={{ xs: 9 }}>
                    <div className="mb-5 need-direction-heading">
                        <div className="primary-card-heading">Need direction?</div>
                    </div>

                    <a href={`${USER_GUIDE_BASE_URL}${CURRENT_USER_GUIDE_SYS_ID}`} target="_blank" className="need-direction-link clickable">
                        <Help /> Check the User guide
                    </a>

                    <div className="need-direction-link clickable" onClick={EmailSafeWorking}>
                        <Feedback /> Email Safe Working
                    </div>

                    <div className="need-direction-link clickable" onClick={SubmitTechFeedback}>
                        <Feedback /> Submit tech feedback
                    </div>
                </Grid2>
            </Grid2>

            <div className="huge-icon">
                <Explore fontSize="inherit" />
            </div>
        </div>
    </div>
);

export default NeedDirectionCard;